export default __webpack_public_path__ + "static/media/telegram-header.feb915a8.svg";